class StickerConfigurator {
  constructor(section) {
    this.section = section;

    this.form = section.querySelector(
      "[data-configurator-form]"
    );

    if (!this.form) return;

    const namespace =
      window.StickerCovenConfigurator;

    if (
      !namespace?.PricingEngine ||
      !namespace?.ConfiguratorUI ||
      !namespace?.CartService ||
      !namespace?.UploadService
    ) {
      console.error(
        "Required sticker configurator modules did not load."
      );

      return;
    }

    this.pricing =
      new namespace.PricingEngine();

    this.ui =
      new namespace.ConfiguratorUI(
        section,
        this.form
      );

    this.cart =
      new namespace.CartService(
        section.dataset.variantId
      );
    this.upload =
      new namespace.UploadService(section);

    this.apippa = null;

    if (namespace?.ApippaService) {
      try {
        this.apippa =
          new namespace.ApippaService();

        this.apippa.connect();
      } catch (error) {
        console.error(
          "Apippa connection failed:",
          error
        );

        this.apippa = null;
      }
    }

    this.isAddingToCart = false;

    this.applyReorderParameters();

    this.bindEvents();
    this.syncPopularSizeState();
    this.upload.observe(() => {
    this.updateAddToCartButton();
  });
    this.update();
  }

  bindEvents() {
    this.form.addEventListener(
      "change",
      (event) => {
        if (
          event.target.matches(
            '[data-option="quantity"]'
          ) &&
          event.target.checked &&
          this.ui.elements.customQuantity
        ) {
          this.ui.elements.customQuantity.value =
            "";
        }

        this.update();
      }
    );

    this.form.addEventListener(
  "input",
  (event) => {
    if (
      event.target ===
      this.ui.elements.customQuantity
    ) {
      const rawValue =
        event.target.value.trim();

      if (rawValue !== "") {
        this.clearPresetQuantity();
      }

      this.update();
    }
  }
);

    this.form.addEventListener(
      "input",
      (event) => {
        if (
          event.target ===
            this.ui.elements.width ||
          event.target ===
            this.ui.elements.height
        ) {
          this.syncPopularSizeState();
          this.update();
          return;
        }

      if (
        event.target ===
        this.ui.elements.customQuantity
      ) {
        const rawValue =
          event.target.value.trim();

        /*
        * As soon as the customer starts typing a
        * custom quantity, stop using the preset.
        */
        if (rawValue !== "") {
          this.clearPresetQuantity();
        }
      }
        this.update();
      }
    );

    this.ui.elements.popularSizes.forEach(
      (button) => {
        button.addEventListener(
          "click",
          () => {
            this.selectPopularSize(button);
          }
        );
      }
    );

    if (this.ui.elements.addToCart) {
      this.ui.elements.addToCart.addEventListener(
        "click",
        () => {
          this.addConfiguredItemToCart();
        }
      );
    }
  }

update() {
  const state = this.getState();

  this.ui.updateSummary(state);
  this.ui.updateTurnaround(
    state.quantity
  );
  try {
    const pricing =
      this.pricing.calculate({
        width: state.width,
        height: state.height,
        quantity: state.quantity
      });

    this.ui.updatePrice(pricing);
  } catch (error) {
    this.ui.showInvalidPrice(
      error.message
    );
  }

  this.updateAddToCartButton();
}
applyReorderParameters() {
  const params =
    new URLSearchParams(
      window.location.search
    );

  if (params.get("reorder") !== "1") {
    return;
  }

  const width =
    Number.parseFloat(
      params.get("width")
    );

  const height =
    Number.parseFloat(
      params.get("height")
    );

  const quantity =
    Number.parseInt(
      params.get("quantity"),
      10
    );

  const shape =
    params.get("shape");

  const finish =
    params.get("finish");

  const border =
    params.get("border");

  const easyPeel =
    params.get("easy_peel");

  this.setReorderDimension(
    this.ui.elements.width,
    width
  );

  this.setReorderDimension(
    this.ui.elements.height,
    height
  );

  this.setReorderRadio(
    "shape",
    shape
  );

  this.setReorderRadio(
    "finish",
    finish
  );

  this.setReorderRadio(
    "border",
    border
  );

  this.setReorderRadio(
    "easy-peel",
    easyPeel
  );

  this.setReorderQuantity(
    quantity
  );

  console.log(
    "Sticker configurator reordered configuration loaded."
  );
}

setReorderDimension(input, value) {
  if (
    !input ||
    !Number.isFinite(value)
  ) {
    return false;
  }

  const minimum =
    Number.parseFloat(input.min);

  const maximum =
    Number.parseFloat(input.max);

  if (
    Number.isFinite(minimum) &&
    value < minimum
  ) {
    return false;
  }

  if (
    Number.isFinite(maximum) &&
    value > maximum
  ) {
    return false;
  }

  input.value = String(value);

  return true;
}

setReorderRadio(
  optionName,
  value
) {
  if (!value) {
    return false;
  }

  const inputs = Array.from(
    this.form.querySelectorAll(
      `[data-option="${optionName}"]`
    )
  );

  const matchingInput =
    inputs.find(
      (input) =>
        input.value === value
    );

  if (!matchingInput) {
    console.warn(
      `Reorder option not found for ${optionName}:`,
      value
    );

    return false;
  }

  inputs.forEach((input) => {
    input.checked =
      input === matchingInput;
  });

  return true;
}

setReorderQuantity(quantity) {
  if (
    !Number.isFinite(quantity) ||
    quantity < 1
  ) {
    return false;
  }

  const presetInputs =
    Array.from(
      this.form.querySelectorAll(
        '[data-option="quantity"]'
      )
    );

  const preset =
    presetInputs.find(
      (input) =>
        Number.parseInt(
          input.value,
          10
        ) === quantity
    );

  if (preset) {
    presetInputs.forEach(
      (input) => {
        input.checked =
          input === preset;
      }
    );

    if (
      this.ui.elements
        .customQuantity
    ) {
      this.ui.elements
        .customQuantity.value = "";
    }

    return true;
  }

  this.clearPresetQuantity();

  if (
    this.ui.elements
      .customQuantity
  ) {
    this.ui.elements
      .customQuantity.value =
        String(quantity);

    return true;
  }

  return false;
}

 getState() {
  const dimensions =
    this.getDimensions();

  return {
    shape:
      this.getCheckedValue("shape"),

    width: dimensions.width,

    height: dimensions.height,

    finish:
      this.getCheckedValue("finish"),

    material:
      this.getCheckedValue("material"),

    whiteInk:
      this.getCheckedValue("white-ink"),

    border:
      this.getCheckedValue("border"),

    easyPeel:
      this.getCheckedValue(
        "easy-peel"
      ),

    quantity: this.getQuantity(),

    usesCustomQuantity:
      this.getCustomQuantity() !== null,

    specialInstructions:
      this.ui.elements.specialInstructions?.value.trim() || "",

    imageSharingConsent:
      this.ui.elements.imageSharingConsent?.checked
        ? "Yes"
        : "No",

    instagramHandle:
      this.ui.elements.instagramHandle?.value.trim() || "",

    threadsHandle:
      this.ui.elements.threadsHandle?.value.trim() || ""
  };
}

  getCheckedValue(optionName) {
    const input = this.form.querySelector(
      `[data-option="${optionName}"]:checked`
    );

    return input ? input.value : "";
  }

  getDimensions() {
    return {
      width: Number.parseFloat(
        this.ui.elements.width?.value
      ),

      height: Number.parseFloat(
        this.ui.elements.height?.value
      )
    };
  }

  getCustomQuantity() {
    const input =
      this.ui.elements.customQuantity;

    if (!input) return null;

    const rawValue =
      input.value.trim();

    if (rawValue === "") return null;

    const quantity =
      Number.parseInt(rawValue, 10);

    if (
      !Number.isFinite(quantity) ||
      quantity < 10
    ) {
      return null;
    }

    return quantity;
  }

  getQuantity() {
    const customQuantity =
      this.getCustomQuantity();

    if (customQuantity !== null) {
      return customQuantity;
    }

    const presetQuantity =
      Number.parseInt(
        this.getCheckedValue(
          "quantity"
        ),
        10
      );

    if (
      !Number.isFinite(
        presetQuantity
      ) ||
      presetQuantity < 1
    ) {
      return null;
    }

    return presetQuantity;
  }

  clearPresetQuantity() {
    this.form
      .querySelectorAll(
        '[data-option="quantity"]'
      )
      .forEach((input) => {
        input.checked = false;
      });
  }

  selectPopularSize(button) {
    const width =
      Number.parseFloat(
        button.dataset.width
      );

    const height =
      Number.parseFloat(
        button.dataset.height
      );

    if (
      !Number.isFinite(width) ||
      !Number.isFinite(height)
    ) {
      return;
    }

    if (this.ui.elements.width) {
      this.ui.elements.width.value =
        width;
    }

    if (this.ui.elements.height) {
      this.ui.elements.height.value =
        height;
    }

    this.ui.setActivePopularSize(
      button
    );

    this.update();
  }

  syncPopularSizeState() {
    const { width, height } =
      this.getDimensions();

    this.ui.syncPopularSizeState(
      width,
      height
    );
  }

  hasValidConfiguration() {
    const state = this.getState();

    const customQuantityInput =
      this.ui.elements.customQuantity;

    if (
      customQuantityInput &&
      customQuantityInput.value.trim() !== ""
    ) {
      const customQuantity =
        Number.parseInt(
          customQuantityInput.value,
          10
        );

      if (
        !Number.isFinite(customQuantity) ||
        customQuantity < 10
      ) {
        return false;
      }
    }

  try {
      this.pricing.calculate({
        width: state.width,
        height: state.height,
        quantity: state.quantity
      });
    } catch (error) {
      return false;
    }

  const pathname =
  window.location.pathname.toLowerCase();

  const isEconomy =
    pathname.includes("economy");

  const isHolographic =
    pathname.includes("holographic");

  return Boolean(
    state.shape &&
    state.finish &&
    state.border &&
    (
      isEconomy ||
      state.easyPeel
    ) &&
    (
      !isHolographic ||
      state.material
    ) &&
    (
      !isHolographic ||
      state.whiteInk
    )
  );    

  return Boolean(
    state.shape &&
    state.finish &&
    state.border &&
    (
      isEconomy ||
      state.easyPeel
    )
  );
  }

    updateAddToCartButton() {
    if (
      this.apippa &&
      !this.apippa.isReady()
    ) {
      this.apippa.connect();
    }

    const enabled =
      !this.isAddingToCart &&
      this.hasValidConfiguration() &&
      Boolean(
        this.apippa?.isReady()
      );

    this.ui.setAddToCartEnabled(
      enabled
    );
  }

  getCartProperties() {
    const state = this.getState();

    const pricing =
      this.pricing.calculate({
        width: state.width,
        height: state.height,
        quantity: state.quantity
      });

    const width =
      this.ui.formatMeasurement(
        pricing.width
      );

    const height =
      this.ui.formatMeasurement(
        pricing.height
      );

    return {
      ...this.upload.getCartProperties(),

      Shape: state.shape,

      Size: `${width}" × ${height}"`,

      Width: width,

      Height: height,

      Finish: state.finish,

      Border: state.border,

      "Easy Peel": state.easyPeel,

      Quantity:
        String(pricing.quantity),

      "_Calculated Price":
        pricing.totalPrice.toFixed(2),

      "_Area":
        pricing.area.toFixed(4),

      "_Area Rate":
        pricing.areaRate.toFixed(2),

      "_Volume Rate":
        pricing.volumeRate.toFixed(2)
    };
  }
async backupUploadsToCart(state) {
  const uploadProperties =
    this.upload.getCartProperties();

  const uploadUrls =
    Object.values(uploadProperties)
      .map((value) =>
        String(value || "").trim()
      )
      .filter((value) =>
        value.startsWith(
          "https://upload.cloudlift.app/"
        )
      );

  if (!uploadUrls.length) {
    return null;
  }

  const randomValues =
    new Uint32Array(1);

  crypto.getRandomValues(
    randomValues
  );

  const configurationId =
    `sc-${Date.now().toString(36)}-${randomValues[0].toString(36)}`;

  const prefix =
    `__sc_upload_${configurationId}`;

  const width =
    this.ui.formatMeasurement(
      state.width
    );

  const height =
    this.ui.formatMeasurement(
      state.height
    );

  const attributes = {
    [`${prefix}_count`]:
      String(uploadUrls.length),

    [`${prefix}_product`]:
      window.location.pathname,

    [`${prefix}_size`]:
      `${width}" x ${height}"`,

    [`${prefix}_quantity`]:
      String(state.quantity),

    [`${prefix}_shape`]:
      state.shape || "",

    [`${prefix}_finish`]:
      state.finish || "",

    [`${prefix}_border`]:
      state.border || "",

    [`${prefix}_easy_peel`]:
      state.easyPeel || ""
  };

  uploadUrls.forEach(
    (url, index) => {
      attributes[
        `${prefix}_${index + 1}`
      ] = url;
    }
  );

  const response = await fetch(
    (
      window.Shopify?.routes?.root ||
      "/"
    ) + "cart/update.js",
    {
      method: "POST",

      headers: {
        "Content-Type":
          "application/json",

        Accept:
          "application/json"
      },

      body: JSON.stringify({
        attributes
      })
    }
  );

  if (!response.ok) {
    throw new Error(
      "Artwork backup could not be saved."
    );
  }

  console.log(
    "Artwork backup saved:",
    configurationId,
    uploadUrls
  );

  return configurationId;
}
  async addConfiguredItemToCart() {
    if (
      this.isAddingToCart ||
      !this.hasValidConfiguration()
    ) {
      return;
    }

    if (
      !this.apippa ||
      !this.apippa.isReady()
    ) {
      this.apippa?.connect();
    }

    if (
      !this.apippa?.isReady()
    ) {
      this.ui.showCartStatus(
        "The pricing form could not be found. Please refresh the page.",
        true
      );

      return;
    }

    this.isAddingToCart = true;

    this.ui.clearCartStatus();
    this.ui.setAddToCartLoading(true);

    try {
      const state = this.getState();
      const currentUploads =
        this.upload.getUploadValues();
      const pricing =
        this.pricing.calculate({
          width: state.width,
          height: state.height,
          quantity: state.quantity
        });

      /*
      * Upload Lift is optional. When an upload exists,
      * its property is injected into Apippa’s real
      * Shopify product form before submission.
      */
      const artworkConfigurationId =
        await this.backupUploadsToCart(
          state
        );

      const extraProperties = {
        ...this.upload.getCartProperties(),

        ...(artworkConfigurationId
          ? {
              "_SC Artwork ID":
                artworkConfigurationId,

              "_SC Artwork Count":
                String(
                  currentUploads.length
                )
            }
          : {}),

        "_Calculated Price":
          pricing.totalPrice.toFixed(2),

        "_Area":
          pricing.area.toFixed(4),

        "_Area Rate":
          pricing.areaRate.toFixed(2),

        "_Volume Rate":
          pricing.volumeRate.toFixed(2),

        "_Image Sharing Consent":
          state.imageSharingConsent,

        "_Instagram Handle":
          state.instagramHandle,

        "_Threads Handle":
          state.threadsHandle,
      };

      await this.apippa.submitConfiguredItem(
        state,
        extraProperties
      );
      this.upload.markSubmitted(
        currentUploads
      );
      this.ui.showCartStatus(
        "Adding to your cart…"
      );
    } catch (error) {
      console.error(
        "Apippa submission failed:",
        error
      );

      this.ui.showCartStatus(
        error.message ||
          "The item could not be added. Please try again.",
        true
      );

      this.isAddingToCart = false;
      this.ui.setAddToCartLoading(false);
      this.updateAddToCartButton();
    }
  }
}
function initializeStickerConfigurators(
  container = document
) {
  container
    .querySelectorAll(
      ".sticker-configurator"
    )
    .forEach((section) => {
      if (
        section.dataset.initialized ===
        "true"
      ) {
        return;
      }

      section.dataset.initialized =
        "true";

      new StickerConfigurator(section);
    });
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    initializeStickerConfigurators();
  }
);

document.addEventListener(
  "shopify:section:load",
  (event) => {
    initializeStickerConfigurators(
      event.target
    );
  }
);